import React from 'react'
import * as XLSX from 'xlsx';

export const useExcelGenerator = () => {

    const exportToExcel = ({ data, headers,temple,from,to }) => {
        if (!data || data.length === 0) return;

        // Convert JSON data to an array of values
        const formattedData = data.map(item => Object.values(item));

        // Insert custom headers at the beginning
        formattedData.unshift(headers);

        // Convert the formatted data to a worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(formattedData);  // AOA (Array of Arrays) format

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        // Generate Excel file and trigger download
        XLSX.writeFile(workbook, `ISSUE REPORT FROM ${from} TO ${to} ,${temple}.xlsx`);
    };

    return {
        exportToExcel
    };
}